// Brazilian Portuguese — scripts/translate-locale.mjs 로 생성 (en.js 기준).
// 손으로 고친 값은 다음 실행에서 덮이지 않는다 (--force 제외).
// 자리표시자({n} 등)가 어긋난 항목은 영어를 그대로 둔다.
export const pt = {
  "uploadTitle": "Enviar fotos",
  "uploadHint": "Clique ou arraste imagens aqui",
  "uploadHintTouch": "Toque para escolher fotos",
  "uploadOr": "ou",
  "takePhoto": "Tirar foto",
  "yourPhotos": "Suas fotos",
  "photoLabel": "Foto {n}",
  "photoCount": "{n} fotos",
  "addPhoto": "Adicionar foto",
  "continue": "Continuar",
  "stepLabel": "Passo {current} de {total}",
  "chooseStyle": "Escolha um estilo de design",
  "describeCustomStyle": "Descreva seu estilo personalizado",
  "uploadReferenceTitle": "Envie uma foto de referência",
  "uploadReferenceHint": "A IA vai combinar o tom, materiais e o clima geral — a foto do seu cômodo não muda.",
  "removeReference": "Remover referência",
  "cleanupOptionTidy": "Organizar",
  "cleanupOptionTidyDesc": "Mantenha os móveis, remova bagunça / lixo / louça / sujeira",
  "cleanupOptionEmpty": "Esvaziar o cômodo",
  "cleanupOptionEmptyDesc": "Remova todos os móveis e decoração. Paredes e piso permanecem",
  "cleanupChooseOption": "Escolha como limpar",
  "layoutOptionFlow": "Melhor circulação",
  "layoutOptionFlowDesc": "Melhore a circulação e o acesso — mais fácil de se movimentar",
  "layoutOptionSpacious": "Mais espaçoso",
  "layoutOptionSpaciousDesc": "Abra linhas de visão e reduza o excesso visual — dá sensação de espaço",
  "planChooseOption": "O que vamos criar a partir da sua planta?",
  "planOption_3d": "Planta 3D",
  "planOption_3dDesc": "A casa toda vista de cima, decorada no estilo que você escolher",
  "planOption_room": "Um cômodo",
  "planOption_roomDesc": "Pinte um cômodo na planta e veja na altura dos olhos",
  "planOption_clean": "Redesenhar a planta",
  "planOption_cleanDesc": "Um esboço ou planta desfocada, redesenhada com nitidez",
  "planCleanKindTitle": "Tipo de desenho",
  "planCleanKind_line": "Preto e branco",
  "planCleanKind_color": "Planta humanizada",
  "planStyleTitle": "Estilo",
  "planRoomTitle": "Qual cômodo?",
  "planRoomSignIn": "Entre para escolher um cômodo na sua planta.",
  "planRoomPaint": "Pinte o cômodo na planta",
  "planRoomPicked": "Cômodo selecionado",
  "planRoomRepaint": "Pintar novamente",
  "planRoomClear": "Limpar",
  "planRoomNamePlaceholder": "Ou digite o nome do cômodo (ex.: quarto principal)",
  "planCropHint": "Recorte a foto deixando só a planta baixa para um resultado mais preciso.",
  "planFirstOnly": "Apenas a primeira foto é usada como planta baixa.",
  "planRoomPickTitle": "Escolha um cômodo",
  "planRoomPickHint": "Pinte o cômodo que quer ver. Um preenchimento simples basta.",
  "planRoomPickDone": "Usar este cômodo",
  "planRoomNeedPick": "Pinte um cômodo na planta ou digite o nome dele.",
  "errNotFloorplan": "Isso não parece uma planta baixa. Envie uma planta baixa ou escolha um estilo.",
  "planRoomFrom": "Cômodo selecionado na planta",
  "planInputLabel": "Planta baixa",
  "planOutput_plan_3d": "Planta 3D",
  "planOutput_plan_room": "Vista do cômodo",
  "planOutput_plan_clean": "Planta redesenhada",
  "planOutput_plan_color": "Planta humanizada",
  "planRoomFromResult": "Ver um cômodo",
  "planRoomMake": "Criar este cômodo",
  "planRoomMeta": "{n} créditos · este cômodo na altura dos olhos, mesma casa",
  "layoutChooseOption": "Escolha como reorganizar",
  "creditEarnHint": "Ganhe créditos entrando diariamente (+1) ou convidando amigos (+5 cada).",
  "languageHint": "Usado também na análise de design.",
  "reuseStyle": "— Reutilizar estilo anterior —",
  "customPlaceholder": "Descreva o estilo que você quer (ex.: 'chalé aconchegante com tons de madeira quentes', 'minimalista futurista com detalhes metálicos')",
  "customStylePublicHint": "O texto do estilo personalizado pode aparecer anonimamente na comunidade. Você pode desativar isso nas configurações da Conta.",
  "communityRankTitle": "Estilos em alta",
  "communityPeople": "{n} pessoas usaram",
  "customStylesChip": "Estilos personalizados",
  "galleryRecentBadge": "Usado há pouco",
  "timeJustNow": "agora mesmo",
  "timeAgoMin": "há {n}m",
  "timeAgoHour": "há {n}h",
  "communityViewAll": "Ver todos",
  "galleryTitle": "Estilos em alta",
  "briefsLabel": "Novidades",
  "briefTopupKicker": "Créditos",
  "briefTopupTitle": "Créditos insuficientes para o próximo projeto",
  "briefTopupLine": "Créditos grátis renovam amanhã. Precisa de mais agora? Compre um pacote.",
  "briefSeasonKicker": "Na temporada",
  "briefSeasonTitle": "{name} chegou",
  "briefSeasonLine": "Um estilo da temporada — por poucas semanas.",
  "briefInviteKicker": "Convite",
  "briefInviteTitle": "Convide um amigo — vocês dois ganham +{n} créditos",
  "briefInviteLine": "Compartilhe seu link. Os créditos chegam assim que ele se cadastrar.",
  "galleryEmpty": "Nada em alta por aqui ainda — os estilos aparecem assim que começarem a ser usados.",
  "galleryBuiltinTitle": "Ranking de estilos do momento",
  "galleryPopularCustom": "Estilos personalizados em alta",
  "galleryDiscoverTitle": "Descubra estilos personalizados",
  "galleryShuffle": "Aleatório",
  "galleryTranslate": "Traduzir",
  "galleryTranslating": "Traduzindo…",
  "galleryOriginal": "Mostrar original",
  "galleryLiveTab": "Ao vivo",
  "galleryLiveWaiting": "Aguardando novos estilos…",
  "galleryLiveTitle": "Sendo usados agora",
  "galleryRecentCustom": "Estilos personalizados recentes",
  "galleryUse": "Usar este estilo",
  "styleShareNotice": "O texto do estilo personalizado pode aparecer anonimamente na comunidade.",
  "styleShareNoticeSettings": "Desativar nas configurações",
  "styleShareNoticeOk": "Entendi",
  "communityTopTitle": "Estilos personalizados populares",
  "communityRecentTitle": "Usados recentemente por outros",
  "communityUses": "Usado {n}×",
  "communityDesigns": "{n} designs",
  "communityDesignsOne": "{n} design",
  "styleShareTitle": "Compartilhar estilos personalizados",
  "styleShareDesc": "Permita que outros descubram e experimentem o texto do seu estilo. Suas fotos nunca são compartilhadas.",
  "additionalRequests": "Pedidos adicionais",
  "optional": "(opcional)",
  "additionalPlaceholder": "Alguma adição específica para o seu estilo {style}? (ex: 'adicionar mesa de centro de madeira', 'usar azul-petróleo como cor de destaque')",
  "addAdditionalRequest": "+ Adicionar pedidos específicos",
  "generateDesign": "Gerar design",
  "back": "Voltar",
  "generatingOne": "A IA está gerando o seu design de interiores…",
  "generatingMany": "A IA está gerando {n} designs consistentes para o seu ambiente…",
  "generatingOneExterior": "A IA está gerando o seu novo design exterior…",
  "generatingManyExterior": "A IA está gerando {n} renderizações exteriores consistentes…",
  "generatingOneGarden": "A IA está gerando o seu novo design de jardim…",
  "generatingManyGarden": "A IA está gerando {n} renderizações de jardim consistentes…",
  "generationFailed": "Falha ao gerar",
  "tryAgain": "Tentar novamente",
  "errNoInternet": "Sem conexão com a internet. Verifique sua rede e tente novamente.",
  "errTimeout": "A IA demorou muito para responder. Tente novamente.",
  "errTooMany": "Muitas solicitações. Aguarde um momento e tente novamente.",
  "errNetwork": "Erro de rede. Verifique sua conexão e tente novamente.",
  "errAI": "O serviço de design com IA encontrou um problema. Tente novamente.",
  "errFileType": "Tipo de arquivo não suportado. Envie uma imagem JPEG, PNG ou WebP.",
  "errFileTooLarge": "Arquivo muito grande. Envie uma imagem com menos de 20MB.",
  "errPhotoRead": "Não foi possível ler esta foto. Tente outra.",
  "errCameraAccess": "Sem acesso à câmera. Permita o acesso nas Configurações.",
  "errCameraCapture": "Não foi possível tirar a foto. Tente novamente.",
  "errCaptionSave": "Não foi possível salvar a legenda. Tente novamente.",
  "imageUnavailable": "Imagem indisponível",
  "designShareText": "Confira este design {style} feito com o archelier",
  "altPhoto": "Foto {n}",
  "altOriginal": "Original {n}",
  "altGenerated": "Design {n}",
  "errInvalidSpace": "Não identificamos um ambiente nesta foto. Use uma foto que mostre um cômodo — parede e chão juntos, ou um canto.",
  "pickAnotherPhoto": "Escolher outra foto",
  "errCustomStyle": "Descreva seu estilo personalizado.",
  "errSignIn": "Falha ao entrar. Tente novamente.",
  "errInsufficientCredits": "Seus créditos acabaram. Volte amanhã para seu bônus diário.",
  "creditCostHint": "{n} fotos usam {c} créditos — {p} por foto.",
  "errCreditsShort": "Você precisa de {need} créditos e tem {have}. Remova uma foto ou convide um amigo para ganhar mais.",
  "credits": "Créditos",
  "creditsOne": "{n} crédito",
  "creditsMany": "{n} créditos",
  "outOfCredits": "Seus créditos acabaram",
  "creditModalTitle": "Obter mais créditos",
  "creditModalDesc": "Seus créditos diários recarregam amanhã. Quer mais agora?",
  "creditModalWallDesc": "Esses foram os designs grátis de hoje. Mais {n} voltam amanhã — ou recarregue agora para continuar.",
  "errOutOfCreditsToday": "Seus créditos de hoje acabaram. {n} designs grátis voltam amanhã — ou recarregue para continuar.",
  "lastFreeHint": "Esse foi o último design grátis de hoje. Mais {n} amanhã.",
  "lastFreeHintCta": "Recarregar agora",
  "creditModalChatFree": "Conversar com o Gio, seu designer, continua grátis.",
  "creditModalGuestTitle": "Entre para continuar criando",
  "creditModalGuestDesc": "Ao entrar, você ganha créditos grátis todos os dias, além de salvar e compartilhar.",
  "creditOptionSignIn": "Entrar e continuar",
  "creditOptionSignInDesc": "Rápido com Google ou Apple",
  "creditOptionInvite": "Convidar um amigo",
  "creditOptionInviteDesc": "Vocês dois ganham +{n} créditos quando ele se cadastrar",
  "comingSoon": "Em breve",
  "close": "Fechar",
  "getAppTitle": "archelier",
  "getAppDesc": "Redesenhe seu próprio espaço no app",
  "getAppCta": "Baixar",
  "appGateTitle": "Continuar no app",
  "appGateDesc": "Criar designs é melhor no app — câmera, designs salvos e resultados mais rápidos.",
  "appGateCta": "Baixar o app",
  "appGateNotNow": "Agora não",
  "dailyBonusHint": "Você ganha {n} créditos grátis todos os dias.",
  "creditsAria": "{n} créditos restantes",
  "accountCreditsTitle": "Créditos",
  "creditsDailyLabel": "Diários, reiniciam à meia-noite",
  "creditsBonusLabel": "Bônus, nunca expiram",
  "creditsResetHint": "Você ganha {n} créditos grátis todo dia. Os créditos bônus de convites não expiram.",
  "creditsInviteCta": "Convide um amigo para +{n}",
  "creditsTopUpCta": "Comprar créditos",
  "inviteMenu": "Convidar amigos",
  "profileShare": "Compartilhar",
  "profileShareText": "Veja os designs de {name} no archelier.",
  "original": "Original",
  "aiDesign": "Design de IA",
  "imageGenFailed": "Falha ao gerar imagem para esta foto",
  "seeAnalysis": "Veja a análise do design abaixo.",
  "analysisTitle": "Análise do Design de Interiores",
  "spaceAnalysis": "Análise do Espaço",
  "styleDescription": "Descrição do Estilo",
  "colorPalette": "Paleta de Cores",
  "furnitureRec": "Recomendações de Móveis",
  "shopFor": "Comprar {item}",
  "shopShort": "Comprar",
  "paintMatch": "Tinta mais próxima",
  "paintCodeCopy": "Copiar código da tinta",
  "paintCodeCopied": "Código copiado",
  "editRegion": "Editar uma parte",
  "editRegionTitle": "Editar este design",
  "editRegionDesc": "Diga à IA o que mudar e o que colocar no lugar. O resto do cômodo continua igual.",
  "editRegionBrushHint": "Diga à IA o que mudar ou adicionar. Para mudar um ponto, pinte sobre ele primeiro — senão ela edita a imagem toda. Para remover algo, pinte e escreva “remover”.",
  "editRegionMeta": "Salvo como novo design · {n} créditos",
  "editedFromBanner": "Esta é uma cópia editada.",
  "viewOriginal": "Ver original",
  "editsOfThisDesign": "Edições deste design",
  "editsOfThisDesignDesc": "Designs que você criou editando partes deste.",
  "chatTitle": "Consultor de design por IA",
  "chatHint": "Faça perguntas sobre este cômodo. A IA analisa seu design e responde com base nele.",
  "chatStart": "Iniciar uma conversa",
  "chatPlaceholder": "Pergunte sobre um móvel, cor ou layout…",
  "chatSend": "Enviar",
  "chatSending": "Pensando…",
  "chatSuggestion1": "Qual luminária deixaria este cômodo mais aconchegante?",
  "chatSuggestion2": "Como posso fazer este espaço parecer maior?",
  "chatSuggestion3": "Quais 3 coisas devo mudar primeiro?",
  "chatTurnsRemaining": "{n} mensagens restantes neste design",
  "chatTurnsExhausted": "Você atingiu o limite de mensagens para este design. Crie um novo design para continuar.",
  "chatErrGeneric": "O consultor não pôde responder. Tente novamente.",
  "chatPro": "Pro — chat ilimitado",
  "chatRetry": "Tentar novamente",
  "commentsTitle": "Comentários",
  "commentPlaceholder": "Adicionar um comentário",
  "commentPost": "Publicar",
  "commentPosting": "Publicando…",
  "commentSignInHint": "Entre para deixar um comentário.",
  "commentEmpty": "Nenhum comentário ainda.",
  "commentDelete": "Excluir",
  "commentDeleteConfirm": "Excluir este comentário?",
  "commentTooLong": "Comentários são limitados a 500 caracteres.",
  "commentErrGeneric": "Não foi possível publicar o comentário. Tente novamente.",
  "commentCount": "{n}",
  "bookmarksTitle": "Minhas Coleções",
  "tabDesigns": "Designs",
  "tabCollections": "Coleções",
  "bookmarksSectionTitle": "Designs salvos",
  "bookmarksEmpty": "Nenhuma coleção ainda. Salve um design para criar um painel.",
  "bookmarksAdd": "Salvar",
  "bookmarksAdded": "Salvo",
  "bookmarksRemove": "Remover dos salvos",
  "bookmarksSignInHint": "Entre para salvar designs.",
  "saved": "Salvos",
  "savedCollectionDefault": "Salvos",
  "follow": "Seguir",
  "unfollow": "Deixar de seguir",
  "following": "Seguindo",
  "followers": "Seguidores",
  "followingTab": "Seguindo",
  "followingEmpty": "Siga pessoas para ver os designs mais recentes aqui.",
  "followersEmpty": "Nenhum seguidor ainda.",
  "followingEmpty2": "Você ainda não segue ninguém.",
  "followSignInHint": "Entre para seguir",
  "cannotFollowSelf": "Você não pode se seguir.",
  "profile": "Perfil",
  "profileNotFound": "Este perfil não existe.",
  "profileDesigns": "Designs",
  "profileDesignsCount": "Designs",
  "profileFollowers": "Seguidores",
  "profileFollowing": "Seguindo",
  "profileBio": "Bio",
  "profileEdit": "Editar perfil",
  "profileMyProfile": "Meu perfil",
  "displayNameLabel": "Nome de exibição",
  "displayNamePlaceholder": "Seu nome ou estúdio (opcional)",
  "displayNameSave": "Salvar nome",
  "displayNameSaved": "Nome salvo",
  "displayNameErrGeneric": "Não foi possível salvar o nome. Tente novamente.",
  "handleLabel": "Nome de usuário",
  "handlePlaceholder": "letras minúsculas, números, underline (3-20 caracteres)",
  "handleSave": "Salvar usuário",
  "handleSaved": "Usuário salvo",
  "handleInvalid": "O usuário deve ter de 3 a 20 caracteres: a-z, 0-9, underline.",
  "handleTaken": "Esse nome de usuário já está em uso.",
  "handleErrGeneric": "Não foi possível salvar o usuário. Tente novamente.",
  "bioPlaceholder": "Fale um pouco sobre você (máx. 200 caracteres)",
  "bioSave": "Salvar bio",
  "bioSaved": "Bio salva",
  "bioErrGeneric": "Não foi possível salvar a bio. Tente novamente.",
  "instagramLabel": "Instagram",
  "instagramPlaceholder": "seu_usuario_instagram",
  "instagramInvalid": "Use apenas letras, números, ponto ou underline (máx. 30).",
  "profileNoDesigns": "Nenhum design ainda.",
  "collections": "Coleções",
  "collectionsTab": "Coleções",
  "collectionMine": "Minhas coleções",
  "collectionEmpty": "Nenhuma coleção ainda.",
  "collectionPublicEmpty": "Nenhuma coleção pública.",
  "collectionItemCount": "{n} itens",
  "collectionEmpty2": "Esta coleção está vazia.",
  "newCollection": "Nova coleção",
  "collectionNamePlaceholder": "Nome da coleção (ex: Ideias para a sala)",
  "collectionCreate": "Criar",
  "collectionDelete": "Excluir coleção",
  "collectionDeleteConfirm": "Excluir esta coleção? Os itens serão removidos.",
  "collectionRename": "Renomear coleção",
  "collectionVisibility": "Coleção pública",
  "collectionVisibilityOn": "Qualquer pessoa com o link pode ver",
  "collectionVisibilityOff": "Apenas você pode ver esta coleção",
  "addToCollection": "Adicionar à coleção",
  "saveToCollection": "Salvar na coleção",
  "collectionAdded": "Adicionado",
  "collectionRemoveFromBoard": "Remover da coleção",
  "collectionShareLink": "Copiar link da coleção",
  "collectionByOwner": "por",
  "collectionNotFound": "Esta coleção não existe ou é privada.",
  "collectionErrCreate": "Não foi possível criar a coleção.",
  "collectionErrSave": "Não foi possível atualizar a coleção.",
  "collectionDone": "Concluído",
  "collectionPickerHint": "Toque em uma coleção para adicionar ou remover este projeto.",
  "uploadAcceptsHint": "Fotos funcionam melhor, mas croquis, elevações, plantas e capturas 3D também funcionam.",
  "examplePhotos": "Exemplos de fotos",
  "detectedInputTypes": {
    "sketch": "Croqui",
    "elevation": "Elevação",
    "floorplan": "Planta baixa",
    "3d_model": "Modelo 3D"
  },
  "floorplanDetectedBanner": "Parece uma planta baixa — renderizamos o maior cômodo de área comum no nível dos olhos. Para focar em um cômodo específico, adicione uma observação ao seu pedido na próxima vez (ex.: \"renderizar o quarto principal\").",
  "floorplanDetectedBannerWithRoom": "Parece uma planta baixa — renderizamos o cômodo {room} no nível dos olhos. Para focar em outro cômodo, adicione uma observação ao seu pedido na próxima vez.",
  "spaceCategoryTitle": "O que você está projetando?",
  "spaceCategories": {
    "interior": "Interior",
    "exterior": "Exterior",
    "garden": "Jardim"
  },
  "exteriorStyles": {
    "halloween": {
      "name": "Halloween",
      "description": "Abóboras esculpidas, lanternas, varanda outonal aconchegante"
    },
    "christmas": {
      "name": "Natal",
      "description": "Guirlandas, luzes quentes, festão de pinheiro"
    },
    "lunar_new_year": {
      "name": "Ano-Novo Chinês",
      "description": "Lanternas vermelhas, detalhes em dourado, faixas festivas"
    },
    "spring_blossom": {
      "name": "Flor de Primavera",
      "description": "Árvores floridas, plantas em tons pastel, iluminação suave"
    },
    "modern_facade": {
      "name": "Fachada Moderna",
      "description": "Geometria limpa, vidros amplos, mistura de materiais"
    },
    "modern_farmhouse": {
      "name": "Farmhouse Moderno",
      "description": "Revestimento branco, acabamento preto, detalhes em madeira"
    },
    "mediterranean": {
      "name": "Mediterrâneo",
      "description": "Estuque, terracota, aberturas em arco"
    },
    "craftsman": {
      "name": "Craftsman",
      "description": "Telhado de madeira, águas baixas, caibros aparentes"
    },
    "contemporary": {
      "name": "Contemporâneo",
      "description": "Linhas marcantes, volumes ousados, materiais industriais"
    },
    "minimalist_exterior": {
      "name": "Exterior Minimalista",
      "description": "Paleta suave, foco em um único material"
    },
    "tudor": {
      "name": "Tudor",
      "description": "Estilo Tudor inglês — enxaimel com telhados íngremes"
    },
    "cape_cod": {
      "name": "Cape Cod",
      "description": "Tradicional da Nova Inglaterra — madeira branca com janelas pretas"
    },
    "japanese_traditional": {
      "name": "Japonês Tradicional",
      "description": "Estrutura de madeira Minka com telhado cerâmico e engawa"
    },
    "mountain_cabin": {
      "name": "Cabana de Montanha",
      "description": "Cabana de tora ou estilo A-frame cercada pela natureza"
    },
    "midcentury_exterior": {
      "name": "Exterior Mid-Century",
      "description": "Modernismo dos anos 50 e 60 — teto plano, vidros amplos, linhas horizontais"
    }
  },
  "gardenStyles": {
    "halloween": {
      "name": "Halloween",
      "description": "Plantação de abóboras, lanternas, jardim outonal nebuloso"
    },
    "christmas": {
      "name": "Natal",
      "description": "Pinheiros iluminados, luzes quentes, jardim de inverno"
    },
    "lunar_new_year": {
      "name": "Ano-Novo Chinês",
      "description": "Lanternas vermelhas, galhos floridos, jardim auspicioso"
    },
    "spring_blossom": {
      "name": "Flores de Primavera",
      "description": "Cerejeiras, tulipas, verde fresco primaveril"
    },
    "modern": {
      "name": "Jardim Moderno",
      "description": "Geometria definida, placas de concreto, plantas arquitetônicas"
    },
    "mediterranean": {
      "name": "Mediterrâneo",
      "description": "Cascalho, oliveira e lavanda, vasos de terracota, pérgola"
    },
    "coastal": {
      "name": "Litorâneo",
      "description": "Capins, madeira de demolição, plantas resistentes à maresia"
    },
    "minimalist": {
      "name": "Minimalista",
      "description": "Um único material, paleta vegetal simples, espaço negativo"
    },
    "zen": {
      "name": "Jardim Zen",
      "description": "Cascalho rastelado, pedras, pouca vegetação"
    },
    "cottage": {
      "name": "Jardim Cottage",
      "description": "Romântico, vegetação densa, plantas perenes mistas"
    },
    "desert": {
      "name": "Desértico / Xeriscape",
      "description": "Resistente à seca, suculentas, cascalho"
    },
    "tropical": {
      "name": "Tropical",
      "description": "Foliagem exuberante, folhas grandes, flores vibrantes"
    },
    "english": {
      "name": "Jardim Inglês",
      "description": "Gramado bem cuidado, cercas vivas, canteiros em camadas"
    }
  },
  "seasonLabel": "Estação",
  "seasons": {
    "none": "Qualquer",
    "spring": "Primavera",
    "summer": "Verão",
    "autumn": "Outono",
    "winter": "Inverno"
  },
  "timeOfDayLabel": "Horário",
  "timesOfDay": {
    "none": "Qualquer",
    "day": "Dia",
    "golden_hour": "Hora dourada",
    "night": "Noite"
  },
  "editRegionReplacementLabel": "O que deve mudar?",
  "editRegionReplacementPlaceholder": "ex.: adicione uma estátua grande perto da porta",
  "editRegionSubmit": "Gerar edição",
  "editRegionGenerating": "Gerando imagem editada…",
  "editRegionMaskRequired": "Pincele sobre a área que você quer alterar primeiro.",
  "editRegionReplacementRequired": "Diga-nos o que colocar ali.",
  "editRegionBrush": "Pincel",
  "editRegionUndo": "Desfazer",
  "editRegionSize": "Tamanho",
  "editRegionClear": "Redefinir",
  "errEditGeneric": "A edição falhou. Tente novamente.",
  "lightingPlan": "Projeto de Iluminação",
  "designTips": "Dicas de Design",
  "startNew": "Iniciar Novo Design",
  "viewMyDesigns": "Ver Meus Designs",
  "favorite": "Favoritar",
  "unfavorite": "Remover dos favoritos",
  "rename": "Renomear",
  "savePromptText": "Faça login para salvar este design, compartilhar e criar mais",
  "guestCreditsLeft": "Resta apenas {n} design grátis. Faça login e comece com {total}.",
  "guestCreditsGone": "Esse foi seu último design grátis. Faça login para receber {total}.",
  "signInGoogle": "Entrar com o Google",
  "signInApple": "Entrar com a Apple",
  "signInDesc": "Salve seus designs e acesse-os quando quiser.",
  "signInPopupBlocked": "O pop-up foi bloqueado. Permita pop-ups nas configurações do navegador.",
  "appName": "archelier",
  "navCreate": "Criar",
  "navGallery": "Galeria",
  "navGio": "Designer",
  "navMain": "Navegação principal",
  "packsTitle": "Recarregar",
  "packDesigns": "cerca de {n} projetos",
  "packBuying": "Abrindo…",
  "packWaiting": "Pagamento concluído — adicionando seus créditos…",
  "packDone": "Créditos adicionados.",
  "packSlow": "Seus créditos estão a caminho. Eles aparecerão em breve — não precisa comprar de novo.",
  "packFailed": "A compra não foi concluída. Se você foi cobrado e os créditos não chegarem, fale com o suporte.",
  "gioRole": "Designer de ambientes",
  "gioAiNote": "IA",
  "gioSignInBody": "Entre para falar com o Gio. Ele analisa fotos do seu espaço e seus projetos anteriores, sugere estilos e pode criar ou editar um projeto diretamente pelo chat.",
  "gioGreeting": "Oi, eu sou o Gio. Envie uma foto do seu espaço, uma imagem ou link de um cômodo que você ama, ou um dos seus projetos — vou sugerir uma ideia e posso criar para você.",
  "gioChipTaste": "Qual é o meu estilo?",
  "gioChipTrend": "O que está em alta esta semana?",
  "gioChipPhoto": "Enviar foto de um cômodo",
  "gioChipMine": "Usar um dos meus projetos",
  "gioTyping": "Gio está pensando…",
  "gioPlaceholder": "Pergunte ao Gio ou cole um link",
  "gioSend": "Enviar",
  "gioAttachPhoto": "Anexar foto",
  "gioPickDesign": "Meus projetos",
  "gioPickEmpty": "Nenhum projeto ainda — crie um primeiro e depois traga para cá.",
  "gioRemove": "Remover",
  "gioToday": "Hoje",
  "gioNoCredits": "Você está sem créditos.",
  "gioError": "O Gio não pôde responder agora. Tente novamente.",
  "gioAlreadyStarting": "Já está iniciando — aguarde um momento.",
  "gioPhotoSkipped": "Algumas fotos não foram adicionadas. Você pode anexar até {n} fotos (JPG, PNG, WebP ou HEIC, com até 20 MB).",
  "gioErrPhotos": "As fotos não foram encontradas. Adicione uma foto do seu espaço e tente novamente.",
  "gioErrPrompt": "O Gio não conseguiu transformar isso em projeto. Tente descrever de um jeito diferente.",
  "gioErrGone": "Esse projeto ou sugestão não está mais disponível.",
  "gioCreditsLow": "{n} créditos restantes · mensagem usa {c}, {p} com foto",
  "gioCreditsLowFree": "{n} créditos restantes · conversar com o Gio é grátis",
  "gioNoCreditsChatFree": "Seus créditos para designs acabaram — conversar continua grátis.",
  "gioDailyLimit": "Conversamos bastante por hoje. Continuamos amanhã.",
  "gioCardEdit": "Editar",
  "gioCardPhotos": "Fotos prontas: {n}",
  "gioCardPhotoFromDesign": "Foto do seu design de {date}",
  "gioCardPhotoFromDesignNoDate": "Foto de um dos seus designs",
  "gioCardPhotoFromChat": "Foto que você compartilhou aqui",
  "gioCardPhotoNew": "Nova foto",
  "gioCardNoPhoto": "Nenhuma foto ainda",
  "gioCardChangePhoto": "Alterar",
  "gioCardAddPhoto": "Adicionar foto",
  "gioCardUploading": "Enviando…",
  "gioCardSame": "Você já tem um design {style} desta foto ({date}).",
  "gioCardSameView": "Ver",
  "gioCardSameHint": "Com o mesmo pedido, o resultado será bem parecido. Para mudar, adicione um pedido acima, fale com o Gio no chat ou abra em Criar.",
  "gioPickPhoto": "Escolha uma foto",
  "gioPickUpload": "Enviar uma nova foto",
  "gioRunEdit": "Editar · {n} créditos",
  "gioRunGenerate": "Criar · {n} créditos",
  "gioRunWithPhoto": "Adicionar foto e criar · {n}/foto",
  "gioOpenInCreate": "Abrir no Criar",
  "gioPaintMyself": "Pintar a área manualmente",
  "gioStarting": "Iniciando…",
  "gioJobMaking": "Criando seu projeto…",
  "gioJobEditing": "Editando seu projeto…",
  "gioJobNotify": "Pode sair — eu aviso quando estiver pronto.",
  "gioJobInvalid": "Essa foto não parece ser de um espaço que eu possa projetar.",
  "gioJobFailed": "Não consegui terminar este.",
  "gioJobRefunded": "Seus créditos foram devolvidos.",
  "gioJobDone": "Pronto — dê uma olhada",
  "gioJobGone": "Este projeto foi excluído.",
  "gioAskAboutDesign": "Pergunte ao Gio sobre este projeto",
  "navFeed": "Feed",
  "navMy": "Meus",
  "navAccount": "Configurações",
  "signIn": "Entrar",
  "signOut": "Sair",
  "deleteAccount": "Excluir conta",
  "deleteAccountTitle": "Excluir sua conta?",
  "deleteAccountWarn": "Isso excluirá permanentemente sua conta e todos os dados vinculados a ela. Esta ação não pode ser desfeita.",
  "deleteAccountItem_designs": "Todos os seus designs, imagens e conversas com Gio",
  "deleteAccountItem_profile": "Seu perfil, nome de usuário e estilos salvos",
  "deleteAccountItem_social": "Comentários, curtidas, seguidores e coleções",
  "deleteAccountItem_credits": "Créditos restantes, incluindo os comprados, e histórico de assinaturas",
  "deleteAccountBilling_web": "Sua assinatura ativa na web será cancelada automaticamente.",
  "deleteAccountBilling_ios": "Sua assinatura da App Store ou do Google Play não será cancelada automaticamente — cancele-a nas configurações de assinaturas da loja.",
  "deleteAccountFinal": "Você será desconectado imediatamente e não poderá recuperar esta conta.",
  "deleteAccountConfirm": "Excluir conta",
  "deleteAccountSubmitting": "Excluindo…",
  "deleteAccountError": "Não foi possível excluir sua conta. Tente novamente.",
  "myDesigns": "Meus Projetos",
  "language": "Idioma",
  "support": "Suporte",
  "terms": "Termos de Serviço",
  "privacy": "Política de Privacidade",
  "signInTerms": "Ao entrar, você concorda com os nossos {terms} e {privacy}.",
  "onboardingSkip": "Pular",
  "onboardingNext": "Avançar",
  "onboardingStart": "Começar",
  "tourTitle": "Conheça o archelier",
  "tourCreate": "Comece aqui. Tire uma foto ou envie um cômodo, exterior ou jardim, escolha um estilo e receba um novo projeto em instantes.",
  "tourGallery": "Galeria — os estilos mais escolhidos no archelier esta semana. Toque em um para testar no seu espaço.",
  "tourGio": "O Gio é seu designer. Mostre uma foto e diga o que deseja — o Gio sugere estilos e cria ou edita o projeto para você.",
  "tourMy": "Seus projetos ficam salvos em Meus. Corrija só uma parte pincelando ou descrevendo, e depois baixe ou compartilhe.",
  "tourStart": "Volte a este botão a qualquer momento para criar outro projeto. Vamos começar com uma foto.",
  "tourReplay": "Ver tour novamente",
  "onboarding": [
    {
      "icon": "photo_camera",
      "title": "Tire foto, desenhe ou envie",
      "desc": "Uma foto do celular funciona melhor, mas o archelier também lê croquis manuais, elevações, plantas baixas e capturas de modelos 3D — tudo detectado automaticamente."
    },
    {
      "icon": "style",
      "title": "+19 estilos, 4 modos inteligentes",
      "desc": "Escolha um estilo pronto, escreva uma descrição, use uma foto de referência ou use os modos Limpeza / Layout para organizar o espaço."
    },
    {
      "icon": "brush",
      "title": "Edite apenas a parte que desejar",
      "desc": "Não gostou de um canto? Pincele sobre ele no resultado e diga à IA o que colocar ali. O restante da foto continua idêntico."
    },
    {
      "icon": "auto_awesome",
      "title": "Experimente agora mesmo",
      "desc": "Você ganha créditos grátis todos os dias. Envie uma foto e seu primeiro projeto fica pronto em cerca de um minuto."
    }
  ],
  "onboardTabFeedTitle": "Explore ideias",
  "onboardTabFeedDesc": "Veja o que outras pessoas criaram e encontre inspiração para o seu espaço.",
  "onboardTabCreateTitle": "Crie com IA",
  "onboardTabCreateDesc": "Envie uma foto, croqui ou planta — a IA vai gerar um projeto novo.",
  "onboardTabMyTitle": "Salve e gerencie",
  "onboardTabMyDesc": "Seus projetos ficam salvos aqui. Compartilhe no feed ou baixe quando quiser.",
  "onboardTabGioTitle": "Pergunte ao Gio",
  "onboardTabGioDesc": "O Gio, nosso designer, sugere estilos a partir das suas fotos e cria ou edita projetos direto no chat.",
  "myDesignsTitle": "Meus Projetos",
  "signInToSee": "Entre para ver seus projetos",
  "signInToSeeDesc": "Seus projetos salvos aparecerão aqui.",
  "loadingDesigns": "Carregando projetos…",
  "errLoadDesigns": "Erro ao carregar projetos. Tente novamente.",
  "retry": "Tentar novamente",
  "noFavorites": "Nenhum favorito ainda.",
  "noDesigns": "Nenhum projeto ainda. Crie o seu primeiro!",
  "createDesign": "Criar projeto",
  "loadMore": "Carregar mais",
  "loading": "Carregando…",
  "errDesignNotFound": "Projeto não encontrado.",
  "errLoadDesign": "Erro ao carregar projeto.",
  "errDeleteDesign": "Erro ao excluir. Tente novamente.",
  "renameTitle": "Renomear projeto",
  "renamePlaceholders": [
    "Reformulação da sala v1",
    "Cozinha — versão iluminada",
    "Renovação do estúdio",
    "Quarto, tons quentes",
    "Varanda, plano B",
    "Espaço de home office",
    "Projeto de cafeteria",
    "Jardim da frente v2"
  ],
  "save": "Salvar",
  "cancel": "Cancelar",
  "deleteTitle": "Excluir projeto?",
  "deleteDesc": "Isso excluirá permanentemente este projeto e todas as suas imagens. Esta ação não pode ser desfeita.",
  "delete": "Excluir",
  "deleting": "Excluindo…",
  "postToFeed": "Publicar no feed",
  "postedToFeedTitle": "Publicado no feed",
  "postedToFeedDesc": "Outros usuários agora podem ver e curtir este projeto no feed.",
  "captionTitle": "Adicionar legenda",
  "captionPlaceholder": "Conte por que você redesenhou este espaço (opcional)",
  "captionEdit": "Editar legenda",
  "captionPost": "Publicar",
  "captionSave": "Salvar",
  "captionCancel": "Cancelar",
  "viewFeed": "Ver feed",
  "generationInProgress": "Projetando seu espaço…",
  "generationKeepBrowsing": "Fique à vontade para navegar — avisaremos quando estiver pronto",
  "generationDone": "Seu projeto está pronto!",
  "generationTapToOpen": "Toque em Abrir para visualizar",
  "generationFailedHint": "Seu crédito não foi cobrado. Tente novamente.",
  "open": "Abrir",
  "copy": "Copiar",
  "copied": "Copiado!",
  "share": "Compartilhar",
  "downloadImages": "Baixar imagens de IA",
  "download": "Baixar",
  "downloadWatermarkHint": "Uma pequena assinatura do archelier fica no canto inferior direito.",
  "modes": {
    "redesign": "Redesign",
    "staging": "Staging de ambiente vazio"
  },
  "styleUsed": "Estilo usado",
  "customDescLabel": "Descrição personalizada:",
  "additionalReqLabel": "Pedidos adicionais:",
  "useStyleAgain": "Usar este estilo novamente",
  "feedTitle": "Comunidade",
  "feedEmpty": "Nenhum projeto público ainda. Seja o primeiro!",
  "feedSortLatest": "Mais recentes",
  "feedSortPopular": "Populares",
  "feedFilterAll": "Todos",
  "useThisStyle": "Testar este estilo",
  "sourceDesignBanner": "Baseado em \"{name}\"",
  "galleryPickBanner": "Criando com {name}",
  "signInToLike": "Entre para curtir projetos",
  "tryApp": "Experimente o archelier",
  "privateTitle": "Este projeto é privado",
  "privateDesc": "O proprietário não tornou este projeto público.",
  "linkNotFoundTitle": "Este link não está disponível",
  "linkNotFoundDesc": "O projeto pode ter sido excluído ou o link está incompleto.",
  "createWithApp": "Criar com archelier",
  "shareViewCTA": "Quer redesenhar seu próprio espaço?",
  "styles": {
    "modern": {
      "name": "Moderno",
      "description": "Linhas limpas, tons neutros, minimalismo contemporâneo"
    },
    "scandinavian": {
      "name": "Escandinavo",
      "description": "Iluminado, materiais naturais, aconchego nórdico"
    },
    "ikea": {
      "name": "IKEA",
      "description": "Design escandinavo funcional, acessível e prático para o dia a dia"
    },
    "japandi": {
      "name": "Japandi",
      "description": "Minimalismo japonês combinado com o aconchego escandinavo"
    },
    "industrial": {
      "name": "Industrial",
      "description": "Materiais brutos, elementos expostos, estética de loft urbano"
    },
    "coastal": {
      "name": "Coastal",
      "description": "Leveza, luz natural e elegância de casa de praia"
    },
    "classic": {
      "name": "Clássico",
      "description": "Elegância atemporal, tecidos nobres e detalhes ornados"
    },
    "artdeco": {
      "name": "Art Déco",
      "description": "Geometria marcante, toques dourados e glamour dos anos 20"
    },
    "midcentury": {
      "name": "Mid-Century Modern",
      "description": "Formas orgânicas, madeira acolhedora e charme retrô dos anos 50–60"
    },
    "maximalist": {
      "name": "Maximalista",
      "description": "Estampas marcantes, camadas ricas e filosofia do excesso"
    },
    "vintage": {
      "name": "Vintage",
      "description": "Charme nostálgico, relíquias antigas e paleta retrô acolhedora"
    },
    "bohemian": {
      "name": "Boho",
      "description": "Espírito livre, tecidos coloridos e ecletismo artístico"
    },
    "tropical": {
      "name": "Tropical",
      "description": "Verde exuberante, fibra natural e clima de resort"
    },
    "cottagecore": {
      "name": "Cottagecore",
      "description": "Campo inglês romântico, florais e tons pastéis suaves"
    },
    "rustic": {
      "name": "Rústico",
      "description": "Madeira de demolição, pedra e aconchego campestre"
    },
    "wabisabi": {
      "name": "Wabi-Sabi",
      "description": "Beleza na imperfeição, texturas brutas e minimalismo japonês"
    },
    "gothic": {
      "name": "Gótico",
      "description": "Drama em tons escuros, veludo e silhuetas ornadas"
    },
    "cyberpunk": {
      "name": "Cyberpunk",
      "description": "Futurismo em neon, superfícies tecnológicas e distopia urbana"
    },
    "taisho_romance": {
      "name": "Taisho Romance",
      "description": "Japão do início do século XX com toques de Art Nouveau"
    },
    "biophilic": {
      "name": "Biofílico",
      "description": "Plantas por toda parte, luz natural e texturas orgânicas"
    },
    "cozy": {
      "name": "Aconchegante",
      "description": "Quentinho, macio e acolhedor — conforto no estilo hygge"
    },
    "gaming": {
      "name": "Gamer",
      "description": "Iluminação RGB, tecnologia moderna e imersão total"
    },
    "minimalist": {
      "name": "Minimalista",
      "description": "Essencial, sem excessos e com espaços livres"
    },
    "mediterranean": {
      "name": "Mediterrâneo",
      "description": "Paredes texturizadas, terracota, arcos e pedra natural"
    },
    "luxury": {
      "name": "Quiet Luxury",
      "description": "Materiais nobres, paleta sóbria e elegância discreta"
    },
    "dark_academia": {
      "name": "Dark Academia",
      "description": "Biblioteca misteriosa — tom vinho, latão e livros empilhados"
    },
    "organic_modern": {
      "name": "Orgânico Moderno",
      "description": "Formas modernas em materiais naturais e brutos"
    },
    "farmhouse": {
      "name": "Farmhouse",
      "description": "Painéis de madeira, pia de avental e charme de fazenda"
    },
    "halloween": {
      "name": "Halloween",
      "description": "Abóboras, velas e clima misterioso de outono"
    },
    "christmas": {
      "name": "Natal",
      "description": "Árvore, guirlandas, luzes quentes e decoração festiva"
    },
    "lunar_new_year": {
      "name": "Ano-Novo Lunar",
      "description": "Vermelho e dourado, lanternas e símbolos de sorte"
    },
    "spring_blossom": {
      "name": "Primavera em Flor",
      "description": "Flores de cerejeira, tons pastéis e luz fresca"
    },
    "custom": {
      "name": "Estilo Personalizado",
      "description": "Descreva a sua visão única de decoração"
    },
    "reference": {
      "name": "Referência",
      "description": "Recrie o tom, materiais e clima de uma foto enviada"
    },
    "floorplan": {
      "name": "Planta baixa",
      "description": "Uma planta 3D ou um desenho limpo a partir da sua planta"
    },
    "cleanup": {
      "name": "Limpeza",
      "description": "Organize a bagunça ou esvazie o espaço — você escolhe"
    },
    "layout": {
      "name": "Layout",
      "description": "Mesmos móveis, melhor disposição — fluido ou amplo"
    }
  },
  "langMismatchNotice": "Esta análise foi gerada em {lang}.",
  "pricingTitle": "Planos que crescem com você",
  "pricingSubtitle": "Comece grátis. Faça upgrade quando precisar de mais gerações e recursos premium.",
  "pricePerMonth": "/ mês",
  "trialCta": "Iniciar teste grátis de {n} dias",
  "accountPlanFreeTitle": "Sua conta é Grátis",
  "accountPlanProTitle": "Você está no Pro",
  "accountPlanTrialTitle": "Você está no Pro — Teste grátis",
  "proTrialBadge": "Teste",
  "proTrialDaysLeft": "{n} dias restantes no seu teste grátis",
  "proTrialIntroTitle": "Ganhe 2 semanas de Pro — grátis",
  "proTrialIntroDesc": "Cadastre-se e comece com {n} créditos grátis.",
  "proTrialFeatures": "Depois mais {n} grátis todo dia. Sem assinatura, nunca.",
  "welcomeSkip": "Continuar sem uma conta",
  "landingHeadline": "redesenhe qualquer ambiente, em segundos.",
  "landingTagline": "Tire uma foto, escolha um estilo e receba um render fotorrealista. Grátis todo dia, sem assinatura.",
  "landingOpenWeb": "Ou continue na web →",
  "landingFeat1": "Renders de interiores por IA",
  "landingFeat2": "Fotorrealista",
  "landingFeat3": "+50 estilos",
  "landingFeat4": "Jardim e exterior",
  "landingFeat5": "Grátis todo dia",
  "landingStoreOn": "Baixar na",
  "landingStoreGet": "Disponível no",
  "lp": {
    "metaTitle": "archelier — Design de interiores com IA a partir de foto, esboço ou planta baixa",
    "metaDescription": "Tire uma foto de qualquer cômodo e receba um projeto fotorrealista em cerca de um minuto. 48 estilos para interiores, exteriores e jardins, plantas 3D, edição com pincel e um designer de IA para conversar. Grátis todos os dias.",
    "heroEyebrow": "Design de interiores com IA",
    "scrollCue": "Veja como funciona",
    "webCta": "Experimente grátis no navegador",
    "orApp": "Ou baixe o app",
    "qrHint": "Escaneie com a câmera do celular. O app avisa assim que seu design estiver pronto.",
    "showEyebrow": "Antes e depois",
    "showTitle": "Uma foto. Um cômodo totalmente novo.",
    "showBody": "Resultados reais, feitos com o archelier. Arraste para comparar.",
    "before": "Antes",
    "after": "Depois",
    "tabRoom": "Sala de estar",
    "tabEmpty": "Cômodo vazio",
    "tabSketch": "Esboço",
    "tabPlan": "Planta baixa",
    "tabExterior": "Exterior",
    "capRoom": "Rústico — a mesma cozinha e sala de estar, mais aconchegantes.",
    "capEmpty": "Escandinavo — um cômodo vazio, mobiliado.",
    "capSketch": "Japandi — um esboço em linhas, transformado em um espaço real.",
    "capPlan": "Modo planta baixa — uma planta 2D transformada em visão 3D de toda a casa.",
    "capExterior": "Minimalista — uma fachada movimentada, redesenhada.",
    "howEyebrow": "Como funciona",
    "howTitle": "Três passos, cerca de um minuto.",
    "how1Title": "Tire uma foto",
    "how1Body": "Qualquer cômodo, do jeito que está — ou um esboço, planta baixa ou captura 3D. Até 3 ângulos do mesmo cômodo.",
    "how2Title": "Escolha um estilo",
    "how2Body": "Escolha um dos 48 estilos, descreva o seu em uma frase ou envie uma foto com o visual que você ama.",
    "how3Title": "Receba seu projeto",
    "how3Body": "Um render fotorrealista do seu espaço, com lista de móveis, paleta de cores e projeto de iluminação.",
    "stylesEyebrow": "Estilos",
    "stylesTitle": "48 estilos, três tipos de espaço.",
    "stylesBody": "28 para interiores, 11 para exteriores e 9 para jardins — além de visuais sazonais para Halloween, Natal, Ano Novo Chinês e primavera.",
    "stylesInterior": "Interior",
    "stylesExterior": "Exterior",
    "stylesGarden": "Jardim",
    "stylesCta": "Explorar a galeria de estilos",
    "modesEyebrow": "Além dos estilos",
    "modesTitle": "Mais cinco formas de transformar um espaço.",
    "modeCustomTitle": "Estilo personalizado",
    "modeCustomBody": "Descreva o visual em uma frase e salve para a próxima vez.",
    "modeReferenceTitle": "Referência",
    "modeReferenceBody": "Envie uma foto que você adora e aproveite o tom, os materiais e a paleta — sem alterar a disposição.",
    "modeCleanupTitle": "Limpeza",
    "modeCleanupBody": "Remova a bagunça e veja o cômodo vazio.",
    "modeLayoutTitle": "Disposição",
    "modeLayoutBody": "Rearranje os móveis existentes em vez de trocá-los.",
    "modePlanTitle": "Planta baixa",
    "modePlanBody": "Transforme uma planta baixa em uma visão 3D da casa toda ou um esboço em um desenho limpo.",
    "editEyebrow": "Edição com pincel",
    "editTitle": "Mude uma coisa de cada vez.",
    "editBody": "Quer trocar apenas o sofá? Circule-o e digite o que prefere no lugar. O archelier altera só essa área e mantém o resto do cômodo intacto — vale também para cor das paredes, tapetes, iluminação e quadros.",
    "editPrompt": "Um sofá de couro vintage",
    "shopTitle": "Compre o que você vê.",
    "shopBody": "Cada projeto inclui lista de móveis, paleta de cores e plano de iluminação, e cada peça traz um link para buscar itens semelhantes.",
    "gioEyebrow": "Gio",
    "gioTitle": "Converse com um designer.",
    "gioBody": "O Gio é seu designer de ambientes com IA em uma aba própria. Envie uma foto do seu cômodo, uma imagem ou link de um espaço que você ama ou um dos seus projetos. O Gio sugere um estilo e cria ou edita o projeto para você, direto no chat.",
    "gioRole": "Designer de ambientes",
    "gioUser": "Esta é minha cozinha e sala de jantar. Acho o ambiente meio frio. Alguma ideia?",
    "gioReply": "Vamos combinar madeira quente, tecidos suaves e iluminação ambiente aconchegante em vez de superfícies frias. Veja uma ideia para testar:",
    "gioCardTitle": "Aconchego Japandi",
    "gioCardBody": "Carvalho natural e gesso texturizado trazem aconchego imediato ao espaço.",
    "gioCardAction": "Criar",
    "priceEyebrow": "Preços",
    "priceTitle": "Grátis todos os dias. Sem assinatura.",
    "price1": "Designs grátis todos os dias, renovados à meia-noite",
    "price2": "Bônus ao criar uma conta",
    "price3": "Convide um amigo e ambos ganham mais",
    "price4": "Precisa de mais? Recarregue com um pacote de créditos",
    "privacyTitle": "Suas fotos continuam sendo suas.",
    "privacyBody": "Suas fotos, comandos e designs nunca são usados para treinar modelos de IA nem para anúncios. Seus designs permanecem privados, a menos que você os compartilhe.",
    "faqTitle": "Dúvidas",
    "faq1Q": "O que é o archelier?",
    "faq1A": "O archelier (Architect + Atelier) é um app de design de interiores com IA para celular e web. Aponte a câmera para um ambiente, escolha um estilo e receba um projeto fotorrealista desse mesmo espaço, com cada móvel identificado e com link. Funciona para interiores, exteriores e jardins.",
    "faq2Q": "Como funciona?",
    "faq2A": "Tire uma foto do cômodo ou envie um esboço, planta baixa ou captura em 3D. Escolha um dos 48 estilos, descreva o seu ou envie uma foto de referência. Em cerca de um minuto, você recebe um render fotorrealista do seu espaço, além de lista de móveis, paleta de cores e projeto de iluminação.",
    "faq3Q": "O archelier é grátis?",
    "faq3A": "Sim. Não há assinatura. Todos recebem designs grátis diariamente, renovados à meia-noite local, além de bônus ao criar uma conta e ao convidar amigos. Se quiser mais, você pode comprar um pacote de créditos.",
    "faq4Q": "Ele transforma plantas baixas em renderização 3D?",
    "faq4A": "Sim. O modo de planta baixa transforma uma planta 2D em uma visualização 3D de toda a casa no estilo escolhido. Ele também pode transformar um rascunho à mão ou uma planta desfocada em um desenho nítido ou colorido.",
    "faq5Q": "Posso combinar com o estilo de uma foto que adorei?",
    "faq5A": "Sim. Escolha o estilo Referência e envie a foto de inspiração. O archelier usa o tom, os materiais e a paleta dessa imagem e os aplica ao seu ambiente, sem copiar o layout.",
    "faq6Q": "Posso alterar apenas uma parte do design?",
    "faq6A": "Sim. Circule a área que deseja mudar — o sofá, o tapete, uma parede — e digite o que prefere no lugar. Apenas essa área é alterada; o restante do ambiente continua igual.",
    "faq7Q": "O que é o Gio?",
    "faq7A": "O Gio é o designer de ambientes com IA do archelier. Envie uma foto do seu cômodo, uma imagem ou link de um espaço que você adorou ou um dos seus designs. O Gio sugere um estilo, cria ou edita o projeto para você no chat e tira dúvidas sobre cores, orçamento e iluminação.",
    "faq8Q": "Minhas fotos são usadas para treinar IA?",
    "faq8A": "Não. O archelier não usa suas fotos, comandos ou designs para treinar modelos de IA nem para anúncios. Seus designs permanecem privados na sua conta, a menos que você os compartilhe.",
    "faq9Q": "Onde posso usar o archelier?",
    "faq9A": "Na App Store, no Google Play e na web em archelier.co. Sua conta e seus designs ficam sincronizados em todos os lugares. O archelier está disponível em 11 idiomas.",
    "ctaTitle": "Redesenhe seu ambiente hoje.",
    "ctaBody": "No celular e na web. Seus designs sincronizados em qualquer lugar.",
    "langLabel": "Idioma"
  },
  "upgradeToPro": "Fazer upgrade para o Pro",
  "creditsPerMonth": "{n} créditos por mês",
  "planFreeName": "Grátis",
  "planFreeTagline": "Experimente o archelier com alguns designs por mês.",
  "planProName": "Pro",
  "planProTagline": "Para designers frequentes que buscam qualidade.",
  "planStudioName": "Studio",
  "planStudioTagline": "Para usuários avançados, equipes e uso comercial.",
  "planFeatWatermark": "Inclui marca d'água \"archelier\"",
  "planFeatNoWatermark": "Sem marca d'água nos designs salvos ou compartilhados",
  "planFeatUnlimited": "Gerações ilimitadas de designs com IA",
  "planFeatUnlimitedChat": "Chat por IA ilimitado por design (grátis: 3 mensagens)",
  "planFeatUnlimitedEdit": "Edições ilimitadas de regiões",
  "planFeatFeed": "Compartilhar no feed",
  "planFeatEverythingPro": "Tudo do Pro",
  "planFeatCommercial": "Direitos de uso comercial",
  "planFeatApiAccess": "Acesso à API (em breve)",
  "planCtaSubscribe": "Assinar",
  "planCtaCurrent": "Seu plano atual",
  "planPopular": "Mais popular",
  "signInToSubscribe": "Entre para assinar",
  "signInToBuy": "Entre para comprar",
  "trialNote": "Teste grátis de {n} dias",
  "creditPacksTitle": "Ou recarregue com pacotes de créditos",
  "creditPacksSubtitle": "Compra única, sem necessidade de assinatura.",
  "packStarterName": "Pacote Starter",
  "packStandardName": "Pacote Standard",
  "packProName": "Pacote Pro",
  "packCreditsAmount": "{n} créditos",
  "packCtaBuy": "Comprar",
  "pricingFootnote": "Preços exibidos em USD. Impostos calculados no pagamento. Cancele quando quiser.",
  "errBillingGeneric": "Ocorreu um erro ao processar sua solicitação. Tente novamente.",
  "accountTitle": "Configurações",
  "accountPlanSection": "Assinatura",
  "accountCreditsSection": "Créditos",
  "accountCreditsDesc": "Os créditos são usados para gerar designs. Recarregue quando quiser.",
  "viewPlans": "Ver planos",
  "changePlan": "Mudar de plano",
  "manageBilling": "Gerenciar cobrança",
  "manageBillingWebHint": "Se você assinou pela web, pode gerenciar em archelier.co.",
  "buyCreditPack": "Comprar pacote de créditos",
  "subRenewsAt": "Renova em {date}",
  "subEndsAt": "Termina em {date}",
  "trialEndsAt": "Teste grátis termina em {date} — converte automaticamente para US$ 9,99/mês",
  "trialCancelEndsAt": "O teste termina em {date} — a assinatura não será renovada",
  "subStatus_past_due": "Pagamento atrasado — atualize sua forma de pagamento.",
  "subStatus_canceled": "Assinatura cancelada.",
  "subStatus_unpaid": "Assinatura não paga.",
  "subStatus_trialing": "Teste grátis ativo.",
  "account": "Conta",
  "pricing": "Preços",
  "upgrade": "Fazer upgrade",
  "inviteTitle": "Convide amigos e ganhe créditos",
  "inviteSubtitle": "Quando um amigo se cadastrar pelo seu link, você ganha +{inviter} créditos e ele ganha +{invitee}.",
  "inviteFriends": "Convidar amigos",
  "inviteSignInHint": "Entre na sua conta para obter seu link de convite.",
  "yourReferralCode": "Seu link de convite",
  "inviteCodeLoading": "Preparando seu link de convite…",
  "inviteLinkHint": "Novos cadastros pelo seu link ganham +{n} créditos iniciais.",
  "copyLink": "Copiar link",
  "shareLink": "Compartilhar link",
  "inviteShareText": "Redesenhe seu espaço com IA no archelier. Use meu link para ganhar +{n} créditos grátis.",
  "redeemTitle": "Tem um código?",
  "redeemDesc": "Digite o código de convite de um amigo ou um cupom para ganhar créditos bônus.",
  "copyCode": "Copiar código",
  "errRefSelf": "Você não pode usar seu próprio código de convite.",
  "landingInviteTitle": "Um amigo convidou você — vocês dois ganham +{n} créditos.",
  "landingInviteAutoIos": "Instale o app e toque neste link de convite novamente — o app vai abrir e seu bônus será adicionado ao se cadastrar.",
  "landingInviteAutoAndroid": "Instale pelo botão da Google Play abaixo e cadastre-se — seu bônus é adicionado automaticamente. Se não for, insira este código em Configurações → Convidar amigos.",
  "landingInviteDesktop": "Cadastre-se aqui e seu bônus é adicionado na hora. Para recebê-lo no app do celular, escaneie o QR code e siga os passos no seu celular.",
  "promoTitle": "Tem um código promocional?",
  "promoDesc": "Digite um código promocional para resgatar créditos bônus.",
  "promoPlaceholder": "ex.: LAUNCH2026",
  "promoRedeem": "Resgatar",
  "promoSuccess": "Resgatado — {n} créditos adicionados à sua conta.",
  "errPromoInvalid": "Este código é inválido.",
  "errPromoExpired": "Este código expirou.",
  "errPromoMaxed": "Este código atingiu o limite de uso.",
  "errPromoUsed": "Você já resgatou este código.",
  "errPromoUserInit": "Recarregue e tente novamente.",
  "errPromoGeneric": "Não foi possível resgatar o código. Tente novamente.",
  "reportThisDesign": "Denunciar este design",
  "reportShort": "Denunciar",
  "reportTitle": "Denunciar design",
  "reportDesc": "Qual é o problema com este design? Apenas os moderadores verão sua denúncia.",
  "reportReason_spam": "Spam ou publicidade",
  "reportReason_nsfw": "Conteúdo sexual ou impróprio",
  "reportReason_copyright": "Violação de direitos autorais",
  "reportReason_other": "Outro",
  "reportNotePlaceholder": "Adicione detalhes (opcional, até 500 caracteres)",
  "reportSubmit": "Enviar denúncia",
  "reportSubmitting": "Enviando…",
  "reportSignInHint": "Faça login para enviar uma denúncia.",
  "reportThanks": "Denúncia recebida",
  "reportThanksDesc": "Vamos analisar e agir se necessário. Obrigado pelo aviso.",
  "errReportGeneric": "Não foi possível enviar a denúncia. Tente novamente em instantes.",
  "blockUser": "Bloquear este usuário",
  "unblockUser": "Desbloquear",
  "blockShort": "Bloquear",
  "blockConfirm": "Bloquear @{handle}? Você não verá os designs nem a atividade dessa pessoa, e ela não poderá interagir com os seus.",
  "blockedUsersMenu": "Usuários bloqueados",
  "blockedUsersTitle": "Usuários bloqueados",
  "blockedUsersDesc": "Usuários que você bloqueou. Os designs deles estão ocultos do seu feed e perfis.",
  "blockedUsersEmpty": "Você não bloqueou ninguém.",
  "profileBlocked": "Você bloqueou este usuário.",
  "profileBlockedAction": "Desbloqueie para ver os designs novamente.",
  "errBlockGeneric": "Não foi possível atualizar o status de bloqueio. Tente novamente.",
  "errBlockedCustomCommand": "Sua solicitação contém palavras não permitidas.",
  "moderationAutoUnlisted": "Este design foi removido automaticamente do feed público pela moderação. Se acha que foi um engano, fale com os administradores.",
  "promptLang": "Brazilian Portuguese"
};
